<template lang="pug">
  .container.grid-lg
    load-manager(:status="status")
      div(v-if='list.length > 0')
        table.table.table-striped.table-hover.table-sm
          thead
            tr
              th #ID
              th Usário
              th Ação
              th Realizado em
              th
          tbody
            router-link.c-hand(
              tag='tr' 
              v-for="log in list" 
              :key='log.id' 
              :to="{name: 'app.log', params: { ...entityParams, id: log.id } }"
            )
              td \#{{ log.id }}
              td {{ log && log.user ? log.user.nome : 'Sem Usuário - Rotina Automática' }}
              td
                span.action {{ log.action }}
              td {{ log.time | date }}
              td
                i.fa.fa-chevron-right
      .empty.mt-2(v-else)
        .empty-icon
          i.icon.icon-search
        p.empty-title.h5 Nenhum log foi encontrado
        p.empty-subtitle Clique no botão para voltar
        .empty-action
          button.btn.btn-primary(@click="$router.go(-1)") Voltar

    .my-2.text-right(v-if='pages > 1')
      btn-paginate(:page='page', :pages='pages', :count='count', @go-page='goPage', @prev-page='prevPage', @next-page='nextPage')
</template>

<script>
import { vuexDefaultMapping } from '@/mixins/list'

export default {
  vuex: { logs: vuexDefaultMapping },

  computed: {
    entityParams() {
      const { entityName, entityId } = this.$route.params
      return { entityName, entityId }
    },
  },

  created() {
    this.fetchList(this.entityParams)
  },
}
</script>

<style lang="stylus" scoped>
.action-Inserir
  color blue
.action-Atualizar
  color orange
.action-Deletar
  color red
</style>
